import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { Content } from 'src/contexts/ContentContext/Content';
import { Checkbox } from 'src/core/interim/Checkbox';
import { useUserHasAnyOfPermissions } from 'src/hooks/useUserHasAnyOfPermissions';
import { ContentId } from 'src/utils/constants/contentId';
import { PurchaseTicketsInput } from 'src/utils/purchaseUtils';
import { Permission } from 'src/WebApiController';

import * as styles from '../TicketGroupInputTable.css';

export const AutoBroadcastSection = () => {
  const canAutoBroadcast = useUserHasAnyOfPermissions(
    Permission.Purchases_CreateAutoBroadcast
  );
  const { getValues, setValue } = useFormContext<PurchaseTicketsInput>();
  const [isAutoBroadcastChecked, setIsAutoBroadcastChecked] = useState(false);

  useEffect(() => {
    setIsAutoBroadcastChecked(
      getValues().ticketGroups.every((tg) => tg.autoBroadcastCreatedListing)
    );
  }, [getValues]);

  if (!canAutoBroadcast) return null;

  return (
    <div className={styles.headerCheckboxSection}>
      <Checkbox
        checked={isAutoBroadcastChecked}
        onChange={(e) => {
          const isChecked = e.target.checked;
          const { ticketGroups } = getValues();
          ticketGroups.forEach((tg, index) => {
            setValue(
              `ticketGroups.${index}.autoBroadcastCreatedListing`,
              isChecked
            );
          });

          setIsAutoBroadcastChecked(isChecked);
        }}
        className={styles.headerCheckbox}
      />
      <Content id={ContentId.AutoBroadcastNewListing} />
    </div>
  );
};
